<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_user')}}</template>
                            <el-input v-model="ajaxSearch.login" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_rank')}}</template>
                            <b-form-select v-model="ajaxSearch.rank">
                                <option value="">-</option>
                                <option v-for="(list,index) in rankList" :key="index" :value="list.name">{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" size="lg" class="float-right mb-3" v-b-modal.addRank v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('rank_list.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <!-- <b-button variant="primary" size="lg" class="ml-1" @click="getEditRank()" v-if="permissionList.includes(permission.edit)">{{$t('rank_list.table_edit')}}</b-button> -->
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteRank()" v-if="permissionList.includes(permission.delete)">{{$t('rank_list.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>      

                <b-modal id="addRank" :title="$t('rank_list.table_add')" hide-footer>
                    <form id="addRankForm" @submit.prevent="addRank">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <b-form-input name="login"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_rank')}}</template>
                            <b-form-select name="rank_id">
                                <option v-for="(list,index) in rankList" :key="index" :value="list.id">{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-button variant="primary" @click="addRank()" class="float-right">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>

                <b-modal id="editRank" :title="$t('rank_list.table_edit')" hide-footer>
                    <form id="editRankForm" @submit.prevent="editRank">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label>{{ajaxEdit.login}}</label>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_rank')}}</template>
                            <b-form-select name="rank_id" v-model="ajaxEdit.rank_id">
                                <option v-for="(list,index) in rankList" :key="index" :value="list.id">{{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-button variant="primary" @click="editRank()" class="float-right">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,rankAjaxTable,rankAdd,getRankEdit,rankEdit,rankDelete,rankInfo} from '@/system/model/rank'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',login:'',rank:'',created_at:''},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            ajaxInfo:[],
            rankList:[],
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'614687',
                edit:'BA9478',
                delete:'25BD2D',
                info:'EAF7E6'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '5'
            },{
                prop: "login",
                label: this.$t('admin.table_username'),
                width: '10'
            },{
                prop: "rank",
                label: this.$t('admin.table_rank'),
                width: '10'
            },{
                prop: "created_at",
                label: this.$t('admin.table_created_at'),
                width: '10'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = rankAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.login,this.ajaxSearch.rank,this.ajaxSearch.created_at);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.rankList = value.data.rank_list;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addRank(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                self.preloader(true);
                var form = document.getElementById('addRankForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = rankAdd(formData);		
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();         
                                self.$bvModal.hide('addRank');   
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                                self.$bvModal.hide('addRank');
                            }
                        });
                    }
                });
            }
        }
        // ,getEditRank(){
        //     if(this.permissionList.includes(this.permission.edit)){
        //         var self = this;
        //         var result = getRankEdit(this.ajaxRow);
        //         this.preloader(true);
        //         result.then(function(value){
        //             self.preloader(false);
        //             if(value.valid){
        //                 self.ajaxEdit = value.data.current_detail;
        //                 self.$bvModal.show('editRank');
        //             }
        //         });
        //     }
        // },editRank(){
        //     if(this.permissionList.includes(this.permission.edit)){
        //         var self = this;
        //         self.preloader(true);
        //         var form = document.getElementById('editRankForm');
        //         var formData = new FormData(form);
        //         formData.append(this.csrfNameKey, this.csrfName); 
        //         formData.append(this.csrfValueKey, this.csrfValue); 
        //         formData.append('id', this.ajaxEdit.id); 
        //         var result = rankEdit(formData);		
        //         result.then(function(value){
        //             self.preloader(false);
        //             if(value.valid){
        //                 self.$swal.fire({
        //                     type: 'success',
        //                     text: self.$t(value.returnMsg),
        //                     onClose: () => {
        //                         self.initialize();         
        //                         self.$bvModal.hide('editRank');   
        //                     }
        //                 });
        //             }else{
        //                 self.preloader(false);
        //                 var text = "";
        //                 if(Array.isArray(value.returnMsg)){
        //                     value.returnMsg.forEach(function (value) {
        //                         text += self.$t(value)+"<br />";
        //                     }); 
        //                 }else{
        //                     text = self.$t(value.returnMsg);
        //                 }

        //                 self.$swal.fire({
        //                     type: 'error',
        //                     html: text,
        //                     onClose: () => {
        //                         self.initialize();            
        //                         self.$bvModal.hide('editRank');
        //                     }
        //                 });
        //             }
        //         });
        //     }
        // }
        ,deleteRank(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = rankDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
